<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a view to display a particular students progress
    *
    * @since 20230727
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2023 Executives On The Web Ltd. All right Reserved.
    */
--->
<template> 
    <div class="card">
        <div :class="['card-header text-center text-20', color, 'text-white']">
            <span v-html="title"></span>
        </div>            
        <div class="card-body line-height-2">
            <div class="row">
                <div v-for="form in forms" :key="form.form.id + '_' + form.complete + '_' + form.partial_completion + '_' + form.form.title" :class="[colClass]">
                    <fieldset v-if="form.form.failedSetting !== undefined && form.form.failedSetting !== null && form.form.failedSetting && form.isAdmin" style="border: 1px solid red;padding:10px;">
                        <legend style="width:auto;font-size:12px;">This section has been hidden after being completed.</legend>
                        <button :class="['btn btn-block border-info mb-2', form.complete && (!isLoggedInUserInList || userCompletedForm(form, loggedInUserId)) ? 'text-success' : (form.partial_completion ? 'text-primary' : 'text-dark')]" @click="clickButton(form)">
                            <i :class="['fa', form.complete ? 'fa-check' : (form.partial_completion ? 'fa-eject' : 'fa-chevron-circle-right')]" aria-hidden="true"></i> {{form.form.title}}
                            <span v-if="form.date !== undefined && form.date !== null">
                                ({{form.date}})
                            </span>
                        </button>
                    </fieldset>
                    <button v-else :class="['btn btn-block border-info mb-2', form.complete && (!isLoggedInUserInList || userCompletedForm(form, loggedInUserId)) ? 'text-success' : (form.partial_completion ? 'text-primary' : 'text-dark')]" @click="clickButton(form)">
                        <i :class="['fa', form.complete ? 'fa-check' : (form.partial_completion ? 'fa-eject' : 'fa-chevron-circle-right')]" aria-hidden="true"></i> {{form.form.title}}
                        <span v-if="form.date !== undefined && form.date !== null">
                            ({{form.date}})
                        </span>
                    </button>
                    <tool-tip v-for="user in usersToComplete" :key="user.id" :text="user.first_name + ' ' + user.last_name" :icon-text="user.first_name.toUpperCase().charAt(0) + user.last_name.toUpperCase().charAt(0)" :type="userCompletedForm(form, user.id) ? 'bg-success' : 'bg-danger'"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        props: {
            title: {
                type: String,
                default: ''
            },
            forms: {
                type: Array,
            },
            extraParams: {
                type: Object
            },
            color: {
                type: String,
                default: 'bg-mustard'
            },
            colClass: {
                type: String,
                default: 'col-sm-6'
            },
            usersToComplete: {
                type: Array,
            },
            loggedInUserId: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
            }
        },
        computed: {
            isLoggedInUserInList: function(){
                if(this.usersToComplete !== undefined && this.usersToComplete !== null){
                    for(var i=0; i<this.usersToComplete.length; i++){
                        if(this.usersToComplete[i].id == this.loggedInUserId){
                            return true;
                        }
                    }
                }
                return false;
            }
        },
        methods: {
            clickButton: function(form) {
                var params = this.extraParams;
                if(form.extraParams !== undefined && form.extraParams !== null){
                    for (const key in form.extraParams) {
                        if (form.extraParams.hasOwnProperty(key)) {
                            params[key] = form.extraParams[key];
                        }
                    }
                }
                this.$emit('click', form, params);
            },
            userCompletedForm: function(form, userId){
                return form.contributedIds.includes(userId)
            }
        }
    }
</script>